var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShown)?_c('router-link',{staticClass:"button is-small is-link",attrs:{"to":_vm.goToId}},[_c('b-icon',{attrs:{"icon":"pencil","size":"is-small"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }